import Vue from 'vue'
import App from './App.vue'
//可以动态修改浏览器标题的插件
//https://blog.csdn.net/wang13679201813/article/details/126639129
import VueWechatTitle from 'vue-wechat-title'
import router from './router'
import store from './store'
import ElementUI, {Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import common from './utils/common'     // 引入公共函数
import '@styles/global.scss';
import 'amfe-flexible';       // 用于自动设置 rem 基准值
import 'weui';
import weui from 'weui.js';
import {http, api} from "@/api/http";
import {request} from "@/api/request";
import {utils} from "@/utils/utils";

Vue.use(VueWechatTitle);
Vue.use(common);
Vue.use(ElementUI);
Vue.prototype.$weui = weui;

// 挂载到vue原型上，全局可以调用
Vue.prototype.$http = http;
Vue.prototype.$api = api;
Vue.prototype.$request = request;
Vue.prototype.$utils = utils;

Vue.config.productionTip = false

console.log('环境', process.env.NODE_ENV);
import Vconsole from 'vconsole';
if (process.env.NODE_ENV !== 'production' || utils.getQueryVariable('isConsole')) {       // 判断环境
    const vConsole = new Vconsole;
}

Vue.prototype.$log = function (...messages) {
    console.log(messages);
};
Vue.prototype.$showLoading = function (text, fullscreen, body, target) {
    return Loading.service({
        text: text,
        fullscreen: fullscreen,
        body: body,
        target: target, 
        background: 'rgp(0,0,0,0.5)'
    });
};

const $$loadingClass = {
    l: null,
    loading(){
        this.l = layer.load(2)
        return this;
    },
    close(){
        layer.close(this.l);
    }
}
// 轻量级的Loading，不会有遮罩
// 使用该对象取代Vue.prototype.$layer
Vue.prototype.$$loading = function() {
    let ins = Object.create($$loadingClass);
    ins.loading();
    return ins;
};
Vue.prototype.$layer = {
    loading() {
        return layer.load(2);
    },
    closeLoading(loadingInstance) {
        layer.close(loadingInstance);
    }
};


checkIsAuthorized(() =>
init(() =>
    {
        router.beforeEach((to, from, next) => {
            next();
        });
        
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
    })
);


/**
 * 进入APP之前检测是否已授权
 * window.location.href = https://localhost:44327/1/Home
 * window.location.origin = https://localhost:44327
 * window.location.pathname = /1/Home
 * @constructor
 */
function checkIsAuthorized(callback) {
    
    //* 判断重定向次数，防止陷入授权死循环 */
    var sessionKey = "checkIsAuthorized";
    var checkIsAuthorizedValue = sessionStorage.getItem(sessionKey);
    if (checkIsAuthorizedValue == undefined || checkIsAuthorizedValue == null) {
        checkIsAuthorizedValue = 0;
    }
    if (checkIsAuthorizedValue > 1) {
        sessionStorage.removeItem(sessionKey);
        alert("idsrv4授权繁忙，请稍后重试！");
        return;
    }
    
    
    var that = this;
    console.log('检查idsrv4授权信息...');
    let xhr = new XMLHttpRequest();
    var url = api.build("/Client/Check");
    xhr.open("GET", url);
    xhr.setRequestHeader("x-requested-with", "XMLHttpRequest");
    xhr.onload = () => {
        let res = JSON.parse(xhr.responseText);
        console.log('check result: ', JSON.parse(xhr.responseText));
        if (res == null) {
            sessionStorage.removeItem(sessionKey);
            console.error('检查idsrv4授权信息错误', xhr);
            alert(xhr.responseText)
        }
        else if (res.code === 401) {
            sessionStorage.setItem(sessionKey, parseInt(checkIsAuthorizedValue) + 1);
            window.location = api.build('Client/RedirectTo?redirectUrl=' + encodeURIComponent(window.location.href));
        }
        else if (res.code === 200) {
            sessionStorage.removeItem(sessionKey);
            Vue.prototype.$work_ctx = res.data;
            callback();
        }
        else {
            sessionStorage.removeItem(sessionKey);
            console.error('检查认证信息错误', xhr);
        }
    };
    xhr.send();
}





function init(callback) {
    console.log('Vue 初始化...');
    
    if (!window.entryUrl) {
        // 记录进入app的url，后面微信sdk签名用
        //https://zhuanlan.zhihu.com/p/32227843
        window.entryUrl = location.href.split('#')[0];
        Vue.prototype.$getWxSignHref = function () {
            const userAgent = navigator.userAgent;
            if (/iPhone|iPad|iPod/i.test(userAgent) && !/wechatdevtools/i.test(userAgent))
                return encodeURIComponent(window.entryUrl.split('#')[0]);
            else
                return encodeURIComponent(window.location.href.split('#')[0]);
        }
    }

    checkEnterInviter();
    checkAccount(callback);
}

function checkEnterInviter()
{
    // 记录当前进入页面邀请人
    // 车主自行下单奖励归属:车主当次进公众号推荐员工
    const urlParams = new URLSearchParams(window.location.search);
    const enterInviterId = urlParams.get('enterInviterId');//进入邀请人 
    const enterInviterType = urlParams.get('enterInviterType');//进入邀请人类型 1团员 2团长 3员工 4电销 无邀请人传0
    if (enterInviterId && enterInviterType) 
    {
        sessionStorage.setItem("enterInviterId", enterInviterId);
        sessionStorage.setItem("enterInviterType", enterInviterType);
    }
    console.log("车主当次进公众号推荐", enterInviterId, enterInviterType);
}

function checkAccount(callback) {
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(window.location.search);
    const switchAccountId = urlParams.get('switchId');// 账户切换switchId、switchMchId
    const switchAccountMchId = urlParams.get('switchMchId');
    if (!switchAccountId || Vue.prototype.$work_ctx.userId == switchAccountId) {
        callback();
        return;
    }

    if (!hash) {
        window.location.href = `${Vue.prototype.$work_ctx.authHost}MchH5?mchId=${switchAccountMchId}&return_url=${encodeURIComponent(window.location.href)}`;
        return;
    }

    // 获取表单数据
    var openId = hash.replace("#", "");
    let formData = new FormData();
    formData.append("MemberId", switchAccountId);
    formData.append("MerchantId", switchAccountMchId);
    formData.append("OpenId", openId);
    // 发送表单数据到服务器
    fetch(Vue.prototype.$api.build('/My/SwitchAccount'), {
        method: "POST",
        body: formData
    })
    .then(res => {
        console.log("提交成功", res, res.ok);
        if (res.ok) {
            window.location.reload();
            return;
        }

        console.log(`切换失败！`, res);
        callback();
    })
    .catch(error => {
        console.log(error);
    });
}